import { PARTNERS_SEED } from '../data/partnersSeed.js';

function formatPartner(partner) {
  const city = partner.city;
  const state = partner.state;

  return {
    ...partner,
    locationLabel: `${city}, ${state}`,
    roleLabel: `${partner.trade} · ${city}, ${state}`,
  };
}

function filterSeed({ slug, featured, active = true, city, state } = {}) {
  let list = PARTNERS_SEED.map((partner) => formatPartner({ ...partner, storage: 'seed' }));

  if (active) list = list.filter((partner) => partner.isActive);
  if (featured === true) list = list.filter((partner) => partner.isFeatured);
  if (featured === false) list = list.filter((partner) => !partner.isFeatured);
  if (slug) list = list.filter((partner) => partner.slug === slug);
  if (city) list = list.filter((partner) => partner.city.toLowerCase() === city.toLowerCase());
  if (state) list = list.filter((partner) => partner.state.toLowerCase() === state.toLowerCase());

  return list.sort((a, b) => a.displayOrder - b.displayOrder || a.name.localeCompare(b.name));
}

export async function fetchPartners(filters = {}) {
  const params = new URLSearchParams();

  if (filters.slug) params.set('slug', filters.slug);
  if (filters.featured === true) params.set('featured', 'true');
  if (filters.featured === false) params.set('featured', 'false');
  if (filters.active === false) params.set('active', 'false');
  if (filters.city) params.set('city', filters.city);
  if (filters.state) params.set('state', filters.state);

  const query = params.toString();
  const url = `/api/partners${query ? `?${query}` : ''}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Partners API returned ${response.status}`);
    }
    const data = await response.json();
    return data.partners || [];
  } catch {
    return filterSeed(filters);
  }
}

export async function fetchFeaturedPartner() {
  const partners = await fetchPartners({ featured: true });
  return partners[0] || null;
}

export async function fetchPartnerBySlug(slug) {
  if (!slug) return null;
  const partners = await fetchPartners({ slug });
  return partners[0] || null;
}
